/* eslint-disable no-throw-literal */
import { useCallback } from "react"
import { useAxiosInstances } from "../../axios-instance"
import { ILocalizacao } from "../../../application/models"

export const useLocalizacaoApi = () => {
    const { axiosAuthInstance } = useAxiosInstances()

    const getLocalizacaoBySearchTermApi = useCallback(async (data: {
        searchTerm: string,
        categoria: keyof ILocalizacao
    }): Promise<ILocalizacao[]> => {
        try {
            const request = await axiosAuthInstance.get('/geo-veles/localizacao', {
                params: {
                    searchTerm: data.searchTerm,
                    categoria: data.categoria
                }
            })

            return request.data.localizacao
        } catch (error) {
            throw error
        }
    }, [axiosAuthInstance])
    return {
        getLocalizacaoBySearchTermApi
    }
}